<div class="asset-config-container" >
    <div class="asset-selection-container">
        <div class="right-section">
            <div class="right-section-top-container">
                <span class="right-section-title">
                    <div class="title">
                        Asset Selection
                    </div>
                    <div class="note">
                        Note: Predefined list of assets based on the selected algorithm
                    </div>
                </span>
                <span class="add-asset-button">
                    <button (click)="onSelectAssetClicked()" [disabled]="assetDuplicatesDetected" *ngIf="mode === CONFIG_MODE.CREATE">
                        <div class="add-asset-button-text">
                            SELECT ASSETS
                            <img *ngIf="!assetDuplicatesDetected" class="add-asset-button-icon addIcon" src=""/>
                            <img *ngIf="assetDuplicatesDetected" class="add-asset-button-icon" src="assets/add-button-disabled.svg"/>
                        </div>
                    </button>
                </span>
            </div>

            <div class="asset-list-container">
                <div class="count-paginator-container">
                    <div class="asset-count" [ngClass]="{'no-assets': count === 0}">
                        {{count > 1 ? "ASSETS" : "ASSET"}} ({{count}})
                    </div>
                    <div class ="paginator" [hidden]="count === 0">
                        <mat-paginator #scheduledOrdersPaginator [hidePageSize]="true" [pageSizeOptions]="[6]" showFirstLastButtons></mat-paginator>
                    </div>
                </div>
                <div class="line-divider">
                    <div class="circle"></div>
                    <div class="line"></div>
                    <div class="circle"></div>
                </div> 
                <div class="table-container">
                    <div class="no-asset-message" [hidden]="count > 0">
                        <img class="icon infoIcon" src=""/>
                        <div class="message">NO ASSETS HAVE BEEN ADDED</div>
                        <div class="note">Click “Select Assets” to Assign Assets</div>
                    </div>
                    <div class="selected-assets-container" [hidden]="count === 0">
                        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0">
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by actionTitle">
                                    Name
                                </th>
                                <td mat-cell *matCellDef="let asset">
                                    <span appTooltip="{{asset.assetName}}" [tooltipPosition]="'top'"
                                    [tooltipShow]="(asset.assetName.length) > 24">
                                        <div class="asset-options-text">
                                            {{asset.assetName | shorten: 24}}
                                        </div>
                                    </span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="buttons">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let asset">
                                    <div class="table-icons" *ngIf="mode === CONFIG_MODE.CREATE">
                                        <button class="delete-asset-button"(click)="deleteSelectedAsset(asset)">
                                                 <img *ngIf="(asset.configured && assetDuplicatesDetected)" class="delete-asset-button-icon show" src="assets/delete-button-red.svg"/>
                                                 <img *ngIf="!asset.configured || !assetDuplicatesDetected" class="delete-asset-button-icon show deleteIcon" src=""/>
                                        </button>
                                    </div> 
                                </td>
                            </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'disabled' : row.configured && assetDuplicatesDetected}"></tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
